// extracted by mini-css-extract-plugin
module.exports = {"formHeadline":"styles_formHeadline__1DHde"};